import * as React from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

export default function Tooltips({title, text}) {
  return (
    <Tooltip title={title} arrow placement="right-end">
      <Button>{text}</Button>
    </Tooltip>
  );
}